import React, {useState, useEffect} from 'react';
import SearchBar from './SearchBar'
import VideoList from './VideoList';
import VideoDetail from './VideoDetail';
import useVideos from '../hooks/useVideos'

const App = () =>{
    
    const [selectedVideo, setSelectedVideo] = useState(null);
    const [videos, search] = useVideos('lo fi music');

    useEffect(() => {
        setSelectedVideo(videos[0]);
    }, [videos]) //Toda vez que reciba una lista de videos, voy a elegir el primer video de la nueva lista. 
    
    return (
        <div className="ui container">
            {/* Prestar atencion a la configuracion de éste callback;(...) */}
            <SearchBar onFormSubmit={search} />
            <div className="ui stackable grid">
                <div className="ui row">
                    <div className="eleven wide column">
                        <VideoDetail video={selectedVideo}/>
                    </div>
                    <div className="five wide column">
                        <VideoList videos={videos} onVideoSelect={setSelectedVideo}/>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default App;